import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { EquitasBankService } from '../services/equitasbank.service';
@Component({
    selector: 'app-equitasbankaudit',
    templateUrl: './equitasbankaudit.component.html',
    styleUrls: ['./equitasbankaudit.component.css']
})
export class EquitasBankAuditComponent implements OnInit {
    displayedColumns = [
        'action',
        'webhook', 
        'customer_code',
        'bene_account_no',
        'bene_account_ifsc',
        'status',
        'bene_full_name',
        'transfer_type',
        'transfer_unique_no',
        'reference_id',
        'transfer_timestamp',
        'transfer_ccy',
        'transfer_amt',
        'rmtr_account_no',
        'rmtr_account_ifsc',
        'rmtr_full_name',
        'rmtr_address',
        'rmtr_to_bene_note',
        'attempt_no',
        'creditAccountNumber',
        'createdAt',
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<equitasBankData>;
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private equitasbank: EquitasBankService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    displayProperJson(jsonData) {
        let obj = {
            jsonData: jsonData,
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.equitasbank.getEquitasBankAudit(this.filter).subscribe((success) => {
                let equitasBankRes = success.map(equitasBankAudit => {
                    equitasBankAudit.createdAt = moment(equitasBankAudit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return equitasBankAudit;
                })
                this.dataSource = new MatTableDataSource(equitasBankRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const equitasbankaudit = await this.dataSource.filteredData.map(x => ({
                "Webhook": x.webhook,
                "Customer Code": x.customer_code,
                "Bene Account No": x.bene_account_no,
                "Bene Account IFSC": x.bene_account_ifsc,
                "Status": x.status,
                "Bene Full Name": x.bene_full_name,
                "Transfer Type": x.transfer_type,
                "Transfer Unique No": x.transfer_unique_no,
                "Reference Id": x.reference_id,
                "Transfer Timestamp": x.transfer_timestamp,
                "Transfer ccy": x.transfer_ccy,
                "Transfer Amtount": x.transfer_amt,
                "rmtr Account No": x.rmtr_account_no,
                "rmtr Account IFSC": x.rmtr_account_ifsc,
                "rmtr Full Name Code": x.rmtr_full_name,
                "rmtr Address": x.rmtr_address,
                "rmtr to bene note": x.rmtr_to_bene_note,
                "Attempt No": x.attempt_no,
                "Credit Account Number": x.creditAccountNumber,
                "Created At": x.createdAt,
            }));
            TableUtil.exportArrayToExcel(equitasbankaudit, "equitasbankaudit");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface equitasBankData {
    action: string,
    webhook: string,
    customer_code: string,
    bene_account_no: string,
    status: string,
    bene_account_ifsc: string,
    bene_full_name: string,
    transfer_type: string,
    transfer_unique_no: string,
    reference_id: string,
    transfer_timestamp: string,
    transfer_ccy: string,
    transfer_amt: string,
    rmtr_account_no: string,
    rmtr_account_ifsc: string,
    rmtr_full_name: string,
    rmtr_address: string,
    rmtr_to_bene_note: string,
    attempt_no: string,
    creditAccountNumber: string,
    createdAt: string,
}


// WEBPACK FOOTER //
// ./src/app/equitasbankaudit/equitasbankaudit.component.ts